import { AnchorButton, Button, ButtonGroup, Icon } from "@blueprintjs/core";
import _ from "lodash";
import moment from "moment";
import { CustomerOrder } from "../../../../api/schema";
import { TableColumns } from "../../../../components/Table";
import { print_url } from "../../../../config";
import { UserLanguage } from "../../../../lang/lang";
import {
  IconMapperState,
  IconMapperStateIntent,
  IconMapperType,
  IconMapperTypeIntent,
} from "../helper";

export interface COL_TableInfo {
  setOpenOrderId: (s: number) => any;
}

export const CustomerOrderListViewTableColumns = (
  info: COL_TableInfo
): TableColumns<CustomerOrder> => ({
  id: { label: UserLanguage().data.id },
  customer_name: { label: UserLanguage().data.customerOrder.customerName },
  customer_contact: {
    label: UserLanguage().data.customerOrder.customerContact,
  },
  delivery_date: {
    label: UserLanguage().data.customerOrder.delivery_date,
    render: (i) => {
      if (i.delivery_date === null) return UserLanguage().data.not_set;
      const date = new Date(i.delivery_date);

      return `${date.toLocaleDateString()} (${moment()
        .locale(UserLanguage().moment_lang_key)
        .to(date)})`;
    },
  },
  state: {
    label: UserLanguage().data.customerOrder.state,
    render: (i) => (
      <div>
        <Icon
          icon={IconMapperState[i.state]}
          style={{ marginRight: 10 }}
          intent={IconMapperStateIntent[i.state]}
        />
        {_.get(UserLanguage().data.customerOrder.states, i.state, i.state)}
      </div>
    ),
  },
  type: {
    label: UserLanguage().data.customerOrder.type,
    render: (i) => (
      <div>
        <Icon
          icon={IconMapperType[i.type]}
          style={{ marginRight: 10 }}
          intent={IconMapperTypeIntent[i.type]}
        />
        {_.get(UserLanguage().data.customerOrder.types, i.type, i.type)}
      </div>
    ),
  },
  updated_at: {
    label: UserLanguage().data.customerOrder.updated_at,
    render: (i) => new Date(i.updated_at).toLocaleString(),
  },
  created_at: {
    label: UserLanguage().data.customerOrder.created_at,
    render: (i) => new Date(i.created_at).toLocaleString(),
  },
  actions: {
    label: UserLanguage().actions.label,
    render: (item) => (
      <ButtonGroup>
        <Button
          intent="primary"
          onClick={() => info.setOpenOrderId(item.id)}
          rightIcon="chevron-right"
          text={UserLanguage().actions.show}
        />
        {/* <AnchorButton
            intent="primary"
            rightIcon="chevron-right"
            href={`/customer/order/${item.id}`}
            target="_blank"
            rel="noreferrer"
            text={UserLanguage().actions.show}
          /> */}
        <AnchorButton
          intent="primary"
          rightIcon="print"
          href={print_url + "customer/order/" + item.id}
          target="_blank"
          rel="noreferrer"
          text={UserLanguage().actions.print}
        />
      </ButtonGroup>
    ),
  },
});
